<template>
  <div>
    <profile-modal-base
      v-if="showBaseModal"
      :is-open="showModal"
      data-test="account-modal"
      @close="close"
    >
      <template #header>
        <profile-modal-header
          :header-text="'Account'"
          :back-target="'profileShowModal'"
        >
        </profile-modal-header>
      </template>
      <modal-row-group
        v-if="showUpgrade"
      >
        <button
          class="button-reset flexbox-row button-row"
          data-test="upsell-button"
          @click="upsell"
        >
          <span class="icon-wrapper">
            <icon name="gift" class="icon-small"></icon>
          </span>
          <span class="text-md font-medium text-brand-primary">
            {{ trialEnabled ? 'Start your trial' : 'Subscribe' }}
          </span>
        </button>
      </modal-row-group>
      <modal-row-group>
        <div
          class="button-reset flexbox-row button-row"
          data-test="email-row"
        >
          <span class="text-md font-medium text-primary">
            Email
          </span>
          <span class="flex-1" />
          <span class="text-md font-medium text-tertiary">
            {{ userEmail }}
          </span>
          <button class="icon-wrapper button-reset" @click="showEmailInformationModal = true">
            <icon name="help-circle" class="icon-small"></icon>
          </button>
        </div>
        <button
          class="button-reset flexbox-row button-row"
          data-test="change-password-button"
          @click="open('changePasswordModal')"
        >
          <span
            class="text-md font-medium text-primary"
          >
            Change Password
          </span>
        </button>
      </modal-row-group>
      <modal-row-group
        v-if="showActivationButton"
      >
        <button
          class="button-reset flexbox-row button-row"
          data-test="ActivationModal"
          @click="open('activationModal')"
        >
          <span
            class="text-md font-medium text-primary"
          >
            Enter Activation Code
          </span>
        </button>
      </modal-row-group>

      <modal-row-group
        v-if="subscriptionReceipt"
      >
        <div
          class="button-reset flexbox-row button-row"
          data-test="subscription-name-row"
        >
          <span>Subscription</span>
          <span class="flex-1"></span>
          <span>{{ subscriptionReceipt.name }}</span>
        </div>
        <div
          class="button-reset flexbox-row button-row"
          data-test="subscription-renewal-row"
        >
          <span>{{ subscriptionEndLabel }}</span>
          <span class="flex-1"></span>
          <span>{{ subscriptionEndDate }}</span>
        </div>
        <button
          v-if="allowUpdates && allowCancellation"
          class="button-reset flexbox-row button-row font-medium"
          data-test="subscription-renewal-row"
          @click="open('updatePaymentInfoModal')"
        >
          Update Payment Info
        </button>
        <div
          v-if="showSubscriptionElsewhere"
          class="button-reset flexbox-row button-row"
          data-test="subscription-renewal-row"
        >
          <span>Subscription Purchased Elsewhere</span>
        </div>
        <button
          v-if="allowCancellation"
          class="button-reset flexbox-row button-row"
          data-test="delete-account-button"
          @click="showCancellationModal = true"
        >
          <span class="text-md font-medium text-error">
            Cancel Subscription
          </span>
        </button>
      </modal-row-group>
    </profile-modal-base>
    <confirmation-modal
      v-if="showCancellationModal"
      :confirm-text="'Confirm'"
      @close="showCancellationModal = false"
      @confirm="tryEndSubscription"
    >
      <template #header>
        End Subscription
      </template>
      <div class="text-sm font-regular">
        You will continue to have access until your current subscription expires.
      </div>
    </confirmation-modal>
    <confirmation-modal
      v-if="showEmailInformationModal"
      :confirm-text="'OK'"
      :hide-cancel="true"
      :is-primary="true"
      :icon-name="'info-circle'"
      :icon-variant="'155eef'"
      @close="showEmailInformationModal = false"
      @confirm="showEmailInformationModal = false"
    >
      <template #header>
        Email cannot be changed
      </template>
      <div class="text-sm font-regular">
        If you have any questions, please contact us at support@hltcorp.com
      </div>
    </confirmation-modal>
  </div>
</template>

<script>
import ConfirmationModal from './ConfirmationModal.vue';
import Icon from '@/components/singletons/icon';
import ProfileModalBase from './ProfileModalBase.vue';
import ProfileModalHeader from './ProfileModalHeader.vue';
import ProfileModalMixin from '@/mixins/profileModal';
import TrialMixin from '@/mixins/trial';
import ModalRowGroup from './ModalRowGroup.vue';
import SubscriptionsMixin from '@/mixins/subscriptions';

const MODAL_NAME = 'accountModal';

export default {
  name: 'AccountModal',
  components: {
    ConfirmationModal,
    Icon,
    ModalRowGroup,
    ProfileModalBase,
    ProfileModalHeader,
  },
  mixins: [ProfileModalMixin, SubscriptionsMixin, TrialMixin],
  data() {
    return {
      showCancellationModal: false,
      showEmailInformationModal: false,
    };
  },
  computed: {
    activators() {
      return this.$store.getters['activation/activators'].filter(a => a.activatorType !== 'Ase');
    },
    showModal() {
      return this.$store.getters['ui/profileModalShown'] === MODAL_NAME;
    },
    userEmail() {
      return this.user.email;
    },
    showActivationButton() {
      return this.activators.length > 0;
    },
    showBaseModal() {
      return !this.showCancellationModal && !this.showEmailInformationModal;
    },
  },
  methods: {
    tryEndSubscription() {
      this.showCancellationModal = false;
      return this.endSubscription();
    },
  },
};
</script>

<style scoped lang="scss">
.icon-wrapper {
  display: grid;
  place-items: center;
  width: rem-calc(20);
}

.button-row {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: rem-calc(8);
  padding: 0 rem-calc(20);
  height: rem-calc(48);
}
</style>
